// extracted by mini-css-extract-plugin
export default {"imgWrap":"homeImage_imgWrap__cGQV7","homeImg":"homeImage_homeImg__-S468"};